// extracted by mini-css-extract-plugin
export default {"header":"Header_header__zwer7","main-image":"Header_main-image__iQOA-"};